var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "custom-tab mt-2" }, [
    _c(
      "div",
      { staticClass: "tab-wrapper" },
      [
        _c(
          "b-tabs",
          {
            ref: "bTabs",
            staticClass: "custom-qtap",
            attrs: {
              justified: "",
              "nav-class": _vm.navContainerClass,
              "no-nav-style": true,
              value: _vm.activeTab
            },
            on: {
              "activate-tab": _vm.handleInnerTabActivated,
              input: _vm.onTabChange
            }
          },
          [_vm._t("default")],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }